import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DebugInfoState {
  isDebugModeOn?: boolean;
}

export const initialDebugInfoState: DebugInfoState = {
  isDebugModeOn: false,
};

const debugInfoSlice = createSlice({
  name: 'DEBUG_INFO',
  initialState: initialDebugInfoState,
  reducers: {
    setIsDebugModeOn: (state, action: PayloadAction<boolean>) => {
      return { ...state, isDebugModeOn: action.payload };
    },
  },
});

export const { setIsDebugModeOn } = debugInfoSlice.actions;

export default debugInfoSlice.reducer;
